<div class="modal-diagrama-viewer" [class.is-open]="isVisible" *ngIf="isVisible">
  <div class="ms-Dialog ms-Dialog--lgHeader diagrama-viewer">
    <div class="ms-Dialog-title" style="display: flex; align-items: center; justify-content: space-between;">
      <span>{{ title }}</span>
      <div class="modal-title-actions" style="display: flex; align-items: center; gap: 8px; margin-left: auto;">
        <button *ngIf="showActionButton"
                class="ms-Button ms-Dialog-action ms-Button--primary modal-action-btn"
                [disabled]="actionButtonDisabled"
                [title]="actionButtonTooltip"
                [attr.aria-label]="actionButtonTooltip"
                (click)="onActionButtonClick()">
          <i *ngIf="actionButtonIcon" class="ms-Icon" [ngClass]="actionButtonIcon" aria-hidden="true"></i>
          <span *ngIf="actionButtonLabel" class="ms-Button-label">{{ actionButtonLabel }}</span>
        </button>
        <button *ngFor="let btn of actionButtons; trackBy: trackByButtonId"
                class="ms-Button ms-Dialog-action ms-Button--primary modal-action-btn"
                [disabled]="btn.disabled"
                [title]="btn.tooltip"
                [attr.aria-label]="btn.tooltip"
                (click)="onActionButtonsClick(btn)">
          <i *ngIf="btn.icon" class="ms-Icon" [ngClass]="btn.icon" aria-hidden="true"></i>
          <span *ngIf="btn.label" class="ms-Button-label">{{ btn.label }}</span>
        </button>
      </div>
    </div>
    <div class="ms-Dialog-content">
      <div class="diagrama-container">
        <!-- Aquí va el contenido proyectado -->
        <ng-content></ng-content>
        <div *ngIf="showLoading" class="loading-message">
          {{ loadingMessage }}
        </div>
      </div>
    </div>
    <div class="ms-Dialog-actions">
      <button 
        class="ms-Button ms-Dialog-action ms-Button--primary"
        (click)="onCloseModal()">
        <span class="ms-Button-label">{{ closeButtonLabel }}</span>
      </button>
    </div>
  </div>
</div>